import { createElement } from 'react';
import { createSvg } from './createSvg.js';
import '@vebox/etui-system';
import '@vebox/etui-system-elements';

const CopyGlyph = /*#__PURE__*/createElement("g", {
  id: "copy"
}, /*#__PURE__*/createElement("path", {
  d: "M68.06,14.84H28.11a1.5,1.5,0,0,0-1.5,1.5v9.87H15.94a1.5,1.5,0,0,0-1.5,1.5V67.66a1.5,1.5,0,0,0,1.5,1.5h40a1.5,1.5,0,0,0,1.5-1.5V57.79H68.06a1.5,1.5,0,0,0,1.5-1.5V16.34A1.5,1.5,0,0,0,68.06,14.84ZM54.39,66.16H17.44V29.21h37ZM66.56,54.79H57.39V27.71a1.5,1.5,0,0,0-1.5-1.5H29.61V17.84h37Z"
}));
const Copy = createSvg({
  name: 'copy',
  path: CopyGlyph
});

export default Copy;
export { CopyGlyph };
